import { Box, Skeleton } from "@mantine/core";

import type { FC } from "react";

export const PageLoader: FC = () => {
  return (
    <Skeleton>
      <Box h="100vh" w="100vw" />
    </Skeleton>
  );
};
